import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedId, clearTypeOfAdditionalModal, clearTypeOfThirdModal, selectCurrentAdditionalModalType, selectCurrentShowTypeOfModal, setTypeOfAdditionalModal } from '../../../features/modal/modalSlice';
import { CloseIcon } from '../../../assets/icons/Svg';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { useEffect, useMemo } from 'react';
import { useMasterData } from '../../../hooks/api/useMasterData';
import { clearSelectedPackageView } from '../../../features/client/clientSlice';
import { useGetPackageItemsQuery } from '../../../features/package/packageApiSlice';
import { getRtkErrorMessage } from '../../../utils/getRtkErrorMessage';
import PackageDetailsTHead from '../../common/theads/PackageDetailsTHead';
import PackageDetailsTBody from '../../common/tbody/PackageDetailsTBody';

interface PackageItemProps {
    selectedId: number | null;
}

export default function PackageDetailsItem({ selectedId }: PackageItemProps) {

    const { getBasicPackage } = useMasterData()
    const { data: packageData, isError: isErrorPackageData, error: errorPackageData, isLoading: isLoadingPackageData, refetch: refetchPackageData, isFetching: isFetchingPackageData } = useGetPackageItemsQuery(selectedId ?? undefined,  { skip: selectedId === null, refetchOnMountOrArgChange: true, })
    const errorMessagePackageData = getRtkErrorMessage(errorPackageData);
    const basicPackageId = getBasicPackage?.packageID
    const dispatch = useDispatch();
    const typeOfAddModal = useSelector(selectCurrentAdditionalModalType);
    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    const typeAdditionalModal = useSelector(selectCurrentAdditionalModalType);

    useEffect(() => {
        if (selectedId) {
            refetchPackageData();
        }
    }, [selectedId]);

    const handleCloseCategoryAndProduct = () => {
        if(typeOfAddModal === 'viewPackageItem' && typeAdditionalModal === 'updateClient') {
            dispatch(clearTypeOfAdditionalModal())
            dispatch(clearSelectedId())
            dispatch(setTypeOfAdditionalModal('updateClient'))
        } else if (typeOfAddModal === 'viewDefaultPackage' && typeOfModalShow === 'newClient') {
            dispatch(clearTypeOfAdditionalModal())
            dispatch(clearSelectedId())
        } 
        else if(typeOfAddModal === 'viewPackageItem') {
            dispatch(clearTypeOfAdditionalModal())
            dispatch(clearSelectedId())
        } 
        else {
            dispatch(clearTypeOfThirdModal())
        }
        dispatch(clearSelectedPackageView())
    }

    const displayValue =  basicPackageId === packageData?.packageID && typeAdditionalModal ===  'updateClient' ? '0' : packageData?.totalValue?.toLocaleString();

    const hasValidItems = packageData?.items?.some(
        (item) =>
            item.productID !== null &&
            item.productName !== null &&
            item.categoryName !== null &&
            item.size !== null &&
            item.price !== null
    );

    const sortedItems = useMemo(() => {
        return packageData?.items
            ?.slice()
            .sort((a, b) => {
                const catA = a.categoryName?.toLowerCase() || '';
                const catB = b.categoryName?.toLowerCase() || '';
                const catCompare = catA.localeCompare(catB);

                if (catCompare !== 0) return catCompare;

                const sizeA = a.size?.toLowerCase() || '';
                const sizeB = b.size?.toLowerCase() || '';

                if (sizeA === 'none' || sizeA === '') return 1;
                if (sizeB === 'none' || sizeB === '') return -1;

                return sizeA.localeCompare(sizeB);
            }) ?? [];
    }, [packageData?.items]);
    
    return (
            <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[102] overflow-hidden">
                <div className="relative w-[90vw] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75vw] lg:max-w-[60vw] overflow-hidden">
                    <div className="flex flex-col w-full min-h-[50dvh] max-h-[80dvh] overflow-hidden">
                        <div className="flex flex-col py-5 h-full">
                            {/* Header */}
                            <div className="flex justify-between items-center py-1">
                                <p className="text-sm font-semibold leading-tight text-slate-900">
                                    {'Package Details'}
                                </p>
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                                    onClick={handleCloseCategoryAndProduct}
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                            <hr className="h-px bg-gray-200 border-0" />
                            <div className='grid grid-cols-3 gap-2 py-4'>
                                <div className='flex flex-col'>
                                    <p className='text-sm'>Name:</p>
                                    <p className='text-sm font-medium'>
                                        {packageData?.packageName}
                                    </p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='text-sm'>Cups:</p>
                                    <p className='text-sm font-medium'>
                                        {packageData?.qty}
                                    </p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='text-sm'>Amount:</p>
                                    <p className='text-sm font-medium'>
                                        {displayValue}
                                    </p>
                                </div>
                            </div>
                            <div className='flex-1 overflow-hidden bg-white rounded border'>
                                <div className='overflow-y-auto h-full'>
                                    <table className='min-w-max w-full'>
                                        <PackageDetailsTHead/>
                                        <PackageDetailsTBody 
                                            prod={sortedItems}
                                            isLoading={isLoadingPackageData}
                                            isError={isErrorPackageData}
                                            errorMessage={errorMessagePackageData}
                                            isEmpty={packageData?.items?.length === 0}
                                        />
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
}
